import React from 'react';
import { FormattedMessage } from 'react-intl';
import reduxStore from './../../../reduxStore';

import storage from "../../../utils/storage";

export default class EditName extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            emptyTitleError: false,
            title: this.props.companyTitle
        };

        this.changeTitle = this.changeTitle.bind(this);
        this.validateTitle = this.validateTitle.bind(this);
        this.blurAction = this.blurAction.bind(this);
    }

    changeTitle(event) {
        let newTitle = event.target.value;

        this.setState({ title: newTitle }, this.validateTitle);
    }

    validateTitle(showErrorMessage = true) {
        let isTitleValid = this.state.title.trim().length > 0;

        if (showErrorMessage) {
            this.setState({emptyTitleError: !isTitleValid});
        }

        return isTitleValid;
    }

    blurAction() {
        if (this.props.companyTitle !== this.state.title) {
            this.props.onBlur("companyTitle", this.state.title);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companyTitle !== this.props.companyTitle) {
            this.setState({title: nextProps.companyTitle}, this.validateTitle);
        }
    }

    render() {
        let user = reduxStore.getState().user;
        let isDossieEnabled = user.appSettings.isDossierEnabled;

        return (
            <div className="edit-third-party__about__input-group">
                <div className="row-label">
                    <label htmlFor="edit-third-party__about__title">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.titleLabel" />
                        {this.props.isRequiredField ? <span className="required-field-star" /> : null}
                    </label>
                </div>
                <div className="edit-third-party__about__title-row">
                    <input type="text" id="edit-third-party__about__title"
                           autoFocus
                           name="companyTitle"
                           value={this.state.title}
                           onChange={this.changeTitle}
                           onBlur={this.blurAction} />
                </div>
                <div className={'edit-third-party__about__empty-title-error' +
                (this.state.emptyTitleError ? '' : ' hidden')}>
                    <FormattedMessage id="Entities_Edit_Error_editThirdParty.emptyTitleError" />
                </div>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditName.jsx